import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-indent-increase",
  "use": "format-indent-increase-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-indent-increase\"><path fill-rule=\"evenodd\" d=\"M21 21v-2H3v2h18ZM3 16l4-4-4-4v8Zm18 1v-2H11v2h10ZM3 5h18V3H3v2Zm18 4V7H11v2h10Zm0 4v-2H11v2h10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol